export default __webpack_public_path__ + "static/media/MT1_activations_XZ.ae33cf47.png";